import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";
import { SCHOOLS_BULLETS } from "../../lib/site";

export default function Schools() {
  return (
    <section
      data-testid="schools-section"
      className="bg-white relative overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Visual */}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] max-w-md mx-auto">
              <div className="absolute inset-0 rounded-3xl nb-border-thick nb-shadow-lg overflow-hidden bg-[#0055FF]">
                <div className="absolute inset-0 bg-dots-light opacity-50" />
              </div>
              {/* Stack of class cards */}
              <div className="absolute left-6 top-6 right-6 bottom-6 grid grid-cols-2 grid-rows-3 gap-3">
                {[
                  { l: "STEM Lab", c: "#FFD700", t: "#1A1A1A" },
                  { l: "Audit + Plan", c: "#FF007F", t: "#FFFFFF" },
                  { l: "Robotics", c: "#00C2B8", t: "#1A1A1A" },
                  { l: "Design", c: "#FF6600", t: "#FFFFFF" },
                  { l: "Portfolios", c: "#FFFFFF", t: "#1A1A1A" },
                  { l: "Showcase", c: "#1A1A1A", t: "#FFD700" },
                ].map((tile, i) => (
                  <div
                    key={i}
                    style={{ backgroundColor: tile.c, color: tile.t }}
                    className="rounded-xl border-2 border-[#1A1A1A] p-3 font-display font-black text-sm sm:text-base flex items-end nb-shadow-sm"
                  >
                    {tile.l}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Copy */}
          <div className="lg:col-span-7">
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#0055FF]">
              For Schools
            </p>
            <h2 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tighter">
              For schools ready to build{" "}
              <span className="bg-[#FFD700] px-2 inline-block">
                future-ready
              </span>{" "}
              learners.
            </h2>
            <p className="mt-5 text-base md:text-lg text-[#4A4A4A] font-medium leading-relaxed max-w-xl">
              We help schools bring creativity, STEAM and real-world problem
              solving into everyday learning through practical programs,
              teacher training and implementation support.
            </p>

            <ul className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl">
              {SCHOOLS_BULLETS.map((b) => (
                <li
                  key={b}
                  className="flex items-start gap-3 bg-[#F8F9FA] border-2 border-[#1A1A1A] rounded-xl px-3 py-2.5"
                >
                  <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-md bg-[#0055FF] text-white">
                    <Check size={14} strokeWidth={3} />
                  </span>
                  <span className="text-sm font-semibold">{b}</span>
                </li>
              ))}
            </ul>

            <Link
              to="/contact"
              data-testid="schools-cta-btn"
              className="mt-9 inline-flex items-center gap-2 bg-[#0055FF] text-white border-2 border-[#1A1A1A] rounded-full px-6 py-3.5 font-bold uppercase text-sm tracking-wide nb-shadow nb-press"
            >
              Bring TinkerShift To Your School{" "}
              <ArrowUpRight size={16} strokeWidth={2.5} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
